import script from "./Home.vue?vue&type=script&setup=true&lang=ts&name=Home"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts&name=Home"

import "./Home.vue?vue&type=style&index=0&id=2e3159ae&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3159ae"]])

export default __exports__